/**
 * Precedent: APR page header — `apps/portal/web/src/pages/apr/compat/PageHeader.tsx`
 * Cloned, not imported (DECISIONS.md D-003). Nothing under pages/apr/ or
 * pages/master-data/ is modified by this module.
 *
 * Markup element for element: a `.rd-page-header-row` holding a `.rd-page-header-text`
 * (`<h1 class="rd-page-title">` plus an optional `<p class="rd-page-subtitle">`) and a
 * `.rd-page-header-actions` slot. The rules for those four classes live in
 * `../source-vocabulary.css`, copied from `pages/apr/source-css/theme.css:625-681` with the
 * line numbers cited there — 22px/600 `#212121` title, 13px `#666` subtitle,
 * `16px 20px 12px` padding over a `1px #e0e0e0` bottom rule.
 *
 * APR's own file renders a hidden `.rd-page-has-back` marker that suppresses the source
 * app's floating Back button. **Not carried**: that button is the source shell's, this
 * module has no such control, and a hidden element whose only job is to switch off something
 * that does not exist here would be a value nobody could explain later.
 *
 * The breadcrumb is NOT drawn here. `AppShell` renders it once for every screen in the
 * product (`packages/ui-kit/src/components/AppShell.tsx:703-735`, and its own comment:
 * "Rendered once for every screen in the product, so no screen draws its own").
 */
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Action buttons rendered on the right. */
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className="rd-page-header-row">
      <div className="rd-page-header-text">
        <h1 className="rd-page-title">{title}</h1>
        {subtitle && <p className="rd-page-subtitle">{subtitle}</p>}
      </div>
      <div className="rd-page-header-actions">{actions}</div>
    </div>
  );
}
